import SystemConfigTypes from 'store/actionTypes/systemConfig'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  pagination: {},
  modules: [],
  selectedModule: {},
  adminPortals: [],
  vehicleTypes: [],
  currentModule: ''
}

const systemConfig = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case SystemConfigTypes.GET_SYSTEM_CONFIG_LIST_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case SystemConfigTypes.GET_MODULES_SUCCESS:
      return { ...state, modules: payload?.items }
    case SystemConfigTypes.UPDATE_CURRENT_MODULES_SUCCESS:
      return { ...state, currentModule: payload }
    case SystemConfigTypes.GET_ALL_SYSTEM_CONFIGS_SUCCESS:
      return { ...state, systems: payload?.systemConfig?.items }
    case SystemConfigTypes.GET_ADMIN_PORTALS_SUCCESS:
      return { ...state, adminPortals: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return {
        ...initialData,
        systems: state.systems,
        modules: state.modules
      }
    default:
      return state
  }
}

export default systemConfig
